// usage:
// const myItems = [{ id: 'hbe6u', name: 'Item 1'}, { id: 'hbe6v', name: 'Item 2'}]
// console.log((myItems |> byId('hbe6v')).name)

export default id => collection => collection.find(item => item.id === id)
